export function getAll() {
  return [
    {
      value: 0,
      name: 'Business',
      text: '營業人',
    },
    {
      value: 1,
      name: 'Saler',
      text: '業務',
    },
    {
      value: 2,
      name: 'Engineer',
      text: '工程師',
    },
    {
      value: 3,
      name: 'Accountant',
      text: '會計師',
    },
    {
      value: 5,
      name: 'Assistant',
      text: '業助',
    },
    {
      value: 6,
      name: 'Admin',
      text: '管理員',
    },
  ]
}

export function normalize(value) {
  if (
    value === null ||
    value === undefined ||
    (typeof value === 'string' && value.trim() === '')
  )
    return null
  const normalizedValue = Number(value)
  return Number.isInteger(normalizedValue) && normalizedValue >= 0
    ? normalizedValue
    : null
}

export function getCurrent() {
  return normalize(window.localStorage['roleType'])
}

export function isGeneralUser(type) {
  const normalizedType = type === undefined ? getCurrent() : normalize(type)
  return normalizedType === 0
}

export function isInternalUser(type) {
  const normalizedType = type === undefined ? getCurrent() : normalize(type)
  return normalizedType !== null && normalizedType > 0
}

export function canInternalUserLogin() {
  return process.env.VUE_APP_ALLOW_INTERNAL_LOGIN === 'true'
}

export function isSaler(type) {
  const normalizedType = type === undefined ? getCurrent() : normalize(type)
  return normalizedType === 1
}

export function isEngineer(type) {
  const normalizedType = type === undefined ? getCurrent() : normalize(type)
  return normalizedType === 2 || normalizedType === 6
}

export function isAccountant(type) {
  const normalizedType = type === undefined ? getCurrent() : normalize(type)
  return normalizedType === 3
}

export function isAssistant(type) {
  const normalizedType = type === undefined ? getCurrent() : normalize(type)
  return normalizedType === 5
}

export function isAdmin(type) {
  const normalizedType = type === undefined ? getCurrent() : normalize(type)
  return normalizedType === 6
}
